type IconProps = {
  color?: string;
  backgroundColor?: string;
  size?: number;
  className?: string;
};

export function IconTransferForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconTransfer className={className} color="currentColor" size={20} />
  );
}

export function IconTransfer({
  color = "#3D3935",
  backgroundColor,
  size = 26,
  className,
}: IconProps) {
  const bgColor = backgroundColor || color;

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M9.43143 23.5134C9.00836 23.9365 8.32243 23.9365 7.89936 23.5134L1.39936 17.0134C1.08953 16.7036 0.996847 16.2376 1.16453 15.8328C1.33221 15.428 1.72723 15.1641 2.1654 15.1641L19.4987 15.1641C20.097 15.1641 20.5821 15.6491 20.5821 16.2474C20.5821 16.8457 20.097 17.3307 19.4987 17.3307L4.78079 17.3307L9.43143 21.9814C9.8545 22.4044 9.8545 23.0904 9.43143 23.5134Z"
        fill={bgColor}
      />
      <path
        d="M16.5686 2.48136C16.9917 2.0583 17.6776 2.0583 18.1007 2.48136L24.6007 8.98137C24.9105 9.2912 25.0032 9.75716 24.8355 10.162C24.6678 10.5668 24.2728 10.8307 23.8346 10.8307L6.5013 10.8307C5.90299 10.8307 5.41797 10.3457 5.41797 9.7474C5.41797 9.14909 5.90299 8.66406 6.5013 8.66406L21.2192 8.66407L16.5686 4.01343C16.1455 3.59036 16.1455 2.90443 16.5686 2.48136Z"
        fill={color}
      />
    </svg>
  );
}